import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["messages", "input", "form", "submitBtn", "drawer", "drawerOverlay", "draftContent", "draftFooter", "draftCountText"]
  static values = { sessionId: Number, draftItemsUrl: String }

  connect() {
    this.scrollToBottom()
    this.observeNewMessages()

    // Turbo送信完了でテキストエリアクリア
    this.boundClearInput = this.clearInput.bind(this)
    this.element.addEventListener("turbo:submit-end", this.boundClearInput)
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
    this.element.removeEventListener("turbo:submit-end", this.boundClearInput)
  }

  keydown(event) {
    if (event.key === "Enter" && !event.shiftKey && !event.isComposing) {
      event.preventDefault()
      const content = this.inputTarget.value.trim()
      if (!content) return
      this.formTarget.requestSubmit()
    }
  }

  clearInput() {
    if (this.hasInputTarget) {
      this.inputTarget.value = ""
      this.resetTextarea()
    }
  }

  resize() {
    const textarea = this.inputTarget
    textarea.style.height = "auto"
    textarea.style.height = `${Math.min(textarea.scrollHeight, 120)}px`
  }

  resetTextarea() {
    const textarea = this.inputTarget
    textarea.style.height = "auto"
  }

  // ドロワー開閉
  toggleDrafts() {
    if (this.drawerTarget.classList.contains("translate-x-full")) {
      this.openDrafts()
    } else {
      this.closeDrafts()
    }
  }

  async openDrafts() {
    // ドロワーを開く
    this.drawerTarget.classList.remove("translate-x-full")
    this.drawerOverlayTarget.classList.remove("hidden")

    // draft_items をサーバーから取得
    try {
      const response = await fetch(this.draftItemsUrlValue, {
        headers: { "Accept": "text/html" }
      })
      if (response.ok) {
        const html = await response.text()
        this.draftContentTarget.innerHTML = html
      }
    } catch (e) {
      // fetch失敗時はそのまま（既存のプレースホルダーを表示）
    }
  }

  closeDrafts() {
    this.drawerTarget.classList.add("translate-x-full")
    this.drawerOverlayTarget.classList.add("hidden")
  }

  // スクロール
  scrollToBottom() {
    if (this.hasMessagesTarget) {
      requestAnimationFrame(() => {
        this.messagesTarget.scrollTo({
          top: this.messagesTarget.scrollHeight,
          behavior: "smooth"
        })
      })
    }
  }

  observeNewMessages() {
    if (!this.hasMessagesTarget) return

    this.observer = new MutationObserver(() => {
      this.scrollToBottom()
    })

    this.observer.observe(this.messagesTarget, {
      childList: true,
      subtree: true
    })
  }
}
